import { render, staticRenderFns } from "./Lateral.vue?vue&type=template&id=6beecb4a&scoped=true&"
import script from "./Lateral.vue?vue&type=script&lang=js&"
export * from "./Lateral.vue?vue&type=script&lang=js&"
import style0 from "./Lateral.vue?vue&type=style&index=0&id=6beecb4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beecb4a",
  null
  
)

export default component.exports